module.exports = __webpack_public_path__ + "img/PGSlot_Lobby_Frame.b707df94.png";